import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { PanelInstrucionHands } from '../../../components/common/PanelInstrucionHands';
import { ModalInfoPromotionV2 } from '../../../components/common/ModalInfoPromotionV2';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { team3_sub1_act_1_01 } from '../../../assets/imgIntruction/tema3';
import { imagesTheme3 } from '../../../assets/tema3';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	panelIntroductionOne: 4,
	panelOperation: 5,
	panelDonuts: 6,
	panelDonutsGoOut: 7,
	panelCar: 8,
	panelUniqueProducts: 9,
	panelOrganizerAndLabeling: 10,
	win: 11
};

const stepClick = {
	paso1: {
		ui: steps.panelOperation,
		object: "cubepaso1"
	},
	paso2: {
		ui: steps.panelDonuts,
		object: "cubepaso2"
	},
	paso3: {
		ui: steps.panelDonutsGoOut,
		object: "cubepaso3"
	},
	paso4: {
		ui: steps.panelCar,
		object: "cubepaso4"
	},
	paso5: {
		ui: steps.panelUniqueProducts,
		object: "cubepaso5"
	},
	paso6: {
		ui: steps.panelOrganizerAndLabeling,
		object: "cubepaso6"
	},
}

export const Theme3SubtopicOneActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema1], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 1 act 1");
			ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_1.sub1_act1_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.listenClick, (step) => {
		const valuesObj = Object.values(stepClick)
		const findStep = valuesObj.find((v) => v.object === step)
		if (!findStep) {
			console.log('no existe');
			return
		}
		setUiToShow(findStep.ui)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.actOne.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Panera" />
					<DialogBarNew
						dialog={`¡Muy bien! Comenzaremos con nuestra primera actividad: "Panera y quesera".`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Ejecución de panera y quesera"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_1.sub1_act1_a02T3)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`¡Gracias por seguir explorando la Tienda Receso! Ahora me gustaría enseñarte los productos con los que nuestros Clientes satisfacen sus antojos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelIntroductionOne);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelIntroductionOne && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las áreas iluminadas."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.actOne.clickBread, stepClick.paso1.object)
							ObserverEmitter.emit(EVENTS.tema3.actOne.moveBread)
							setUiToShow(-1);
						}}
						img={team3_sub1_act_1_01}
					/>
				</>
			)}

			{uiToShow === steps.panelOperation && (
				<>
					<ModalInfoPromotionV2
						title={"Horario de operación: 24 horas"}
						description={
							`Aprovecha el momento en que la panera se vacíe, limpia con sanitizante, papel secante y tu trapo azul.`
						}
						url={imagesTheme3.topic1.PaneraBacia}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.actOne.clickBread, stepClick.paso2.object)
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}

			{uiToShow === steps.panelDonuts && (
				<>
					<ModalInfoPromotionV2
						title={"Tiempo de vida del pan exhibido"}
						description={
							`Las donas cuentan con una duración de 3 a 5 días, verifica que las pinzas grises se encuentren en su lugar para el Cliente.`
						}
						url={imagesTheme3.topic1.Donas}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.actOne.clickBread, stepClick.paso3.object)
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}

			{uiToShow === steps.panelDonutsGoOut && (
				<>
					<ModalInfoPromotionV2
						title={"Para Llevar"}
						description={
							`Verifica que en todo momento al lado de la panera haya un mínimo de 5 cajas disponibles para el Cliente, así como una caja de papel encerado.`
						}
						url={imagesTheme3.topic1.CajaDonas}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.actOne.clickBread, stepClick.paso4.object)
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}

			{uiToShow === steps.panelCar && (
				<>
					<ModalInfoPromotionV2
						title={"Devoluciones y entregas de productos"}
						description={
							`Todo el producto debe ser entregado al CEDIS, en retorno, ellos deberán entregarte producto nuevo. Verifica que la cantidad sea correcta y esté en buen estado.`
						}
						url={imagesTheme3.topic1.Cedis}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.actOne.clickBread, stepClick.paso5.object)
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}

			{uiToShow === steps.panelUniqueProducts && (
				<>
					<ModalInfoPromotionV2
						title={"Productos únicos"}
						description={
							`Nuestra panera es exclusiva para exhibir el Pan a Granel y el Pan Empacado, todo debe provenir de Proveedores Locales.`
						}
						url={imagesTheme3.topic1.Panera}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.actOne.clickBread, stepClick.paso6.object)
							setUiToShow(-1);
						}}
					></ModalInfoPromotionV2>
				</>
			)}

			{uiToShow === steps.panelOrganizerAndLabeling && (
				<>
					<ModalInfoPromotionV2
						title={"Organización y etiquetado"}
						description={
							`Debes observar y verificar que los precios sean correctos, de igual manera, ser muy cuidadosos en no dejar etiquetas en mal estado.`
						}
						url={imagesTheme3.topic1.Precio}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema3.actOne.clickBread)
							setUiToShow(steps.win);
						}}
					></ModalInfoPromotionV2>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Es importante recordar el tiempo de vida del pan exhibido."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema1
								})
							);
							navigator("/home3/tema3/subtema1/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}
